var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "confirm-dialog",
          staticStyle: { "margin-top": "12vh" },
          attrs: {
            visible: _vm.confirmTipDialog,
            "modal-append-to-body": false,
            width: "380px",
            height: "170px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.confirmTipDialog = $event
            }
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }),
          _c("div", { staticClass: "confirm-mass-wrap" }, [
            _c("div", { staticClass: "wrap-tip" }, [
              _c("i", { staticClass: "el-icon-warning icon-sty" })
            ]),
            _c("div", { staticClass: "wrap-content" }, [
              _c("div", { staticClass: "content-text" }, [
                _vm._v("修改的内容尚未保存，确认离开此页？")
              ])
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { size: "small" },
                  on: { click: _vm.levelconfirm }
                },
                [_vm._v("离开此页")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.confirmTipDialog = false
                    }
                  }
                },
                [_vm._v("留在此页")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }